import { createContext } from "react";
import { RefOptionsContextValue } from "./types";

export const RefOptionsContext = createContext<RefOptionsContextValue | null>(
  null,
);
